export const GET_BLOOD_TEST_SUCCESS = "GET_BLOOD_TEST_SUCCESS";
export const GET_BLOOD_TEST_ERROR = "GET_BLOOD_TEST_ERROR";
